
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';

import { NotificationManager } from 'react-notifications';
import {
   ALL_INJURYCHARTS,
   ADD_INJURYCHART,
   INJURYCHART_ACTION,
   EDIT_INJURYCHART,
   FETCH_INJURYCHART,
   DELETE_INJURYCHART,
   ALL_INJURYUPDATES,
   ADD_INJURYUPDATE,
   INJURYUPDATE_ACTION,
   EDIT_INJURYUPDATE,
   FETCH_INJURYUPDATE,
   DELETE_INJURYUPDATE,
   ALL_STUDENTINJURY,
   FULL_INJURYDETAIL,
   INJURY_UPDATEDETAIL,
   EDIT_INJURYPROFILE,
   PROFILE_INJURYUPDATE,
   PROFILE_INJURYREPORT,
   ALL_INJURYREPORTS,
   DELETE_INJURYREPORTS,
   ALL_INJURYPROFILE,
   FULL_INJURYPROFILE
} from 'Actions/types';

/**
 * MSK Findings Chart Actions
 */
export const allInjuryChart = () =>{
    
    
    return (dispatch) => { 
        dispatch({ type: INJURYCHART_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getinjurychart', { headers: AuthHeader.header })         
        .then(response => {             
            const allroles=response.data.data;
            dispatch({ type: ALL_INJURYCHARTS, payload: allroles });
        });
    }
    

}

export const addInjuryChart = (teamval) => async (dispatch) => {
    
    var payload={
        "student":teamval.target.student.value,
        "seldate":teamval.target.seldate.value,
        "teamid":teamval.target.teamid.value,
        "age":teamval.target.age.value,
        "gender":teamval.target.gender.value,
        "skill":teamval.target.skill.value,
        "chief_complaint":teamval.target.chief_complaint.value,
        "mechanism_injury":teamval.target.mechanism_injury.value,
        "history_present_injury":teamval.target.history_present_injury.value,
        "history_injury_past":teamval.target.history_injury_past.value,
        "observations_assessment":teamval.target.observations_assessment.value,
        "clinical_findings":teamval.target.clinical_findings.value,
        "provisional_diagnosis":teamval.target.provisional_diagnosis.value,
        "injury_severity":teamval.target.injury_severity.value,
        "consultation_investigations":teamval.target.consultation_investigations.value,
        "plan_action":teamval.target.plan_action.value,
        "restrictions":teamval.target.restrictions.value,
        "return_sports":teamval.target.return_sports.value,
        "sc_team":teamval.target.sc_team.value,
        "coaching_team":teamval.target.coaching_team.value
     }
     dispatch({ type: INJURYCHART_ACTION });
    return axios.post(AppConfig.apiurl+'/api/addinjurychart', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allInjuryChart()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: ADD_INJURYCHART });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }else{
            NotificationManager.error('Injury Chart not added');
         }            
         return Promise.resolve(resdata);
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const fetchInjuryChart = (id) => async (dispatch) => {
	
	var payload={
		"id":id
	}
	
	  dispatch({ type: INJURYCHART_ACTION});
		 return axios.post(AppConfig.apiurl+'/api/fetchinjurychart', payload, { headers: AuthHeader.header })
			.then( response => {   
				var resdata=response.data;	
				var resvalue=resdata.data;			
				dispatch({ type: FETCH_INJURYCHART, payload:resvalue[0]}); 
				return Promise.resolve(resdata);
				
			})
			.catch( error => { 
				const errormsg=error.message
				NotificationManager.error(errormsg);
			});

	
}

export const editInjuryChart = (teamval) => async (dispatch) => {
    
    var payload={
        "id":teamval.target.eid.value,
        "teamid":teamval.target.teamid.value,
        "age":teamval.target.age.value,
        "gender":teamval.target.gender.value,
        "skill":teamval.target.skill.value,
        "chief_complaint":teamval.target.chief_complaint.value,
        "mechanism_injury":teamval.target.mechanism_injury.value,
        "history_present_injury":teamval.target.history_present_injury.value,
        "history_injury_past":teamval.target.history_injury_past.value,
        "observations_assessment":teamval.target.observations_assessment.value,
        "clinical_findings":teamval.target.clinical_findings.value,
        "provisional_diagnosis":teamval.target.provisional_diagnosis.value,
        "injury_severity":teamval.target.injury_severity.value,
        "consultation_investigations":teamval.target.consultation_investigations.value,
        "plan_action":teamval.target.plan_action.value,
        "restrictions":teamval.target.restrictions.value,
        "return_sports":teamval.target.return_sports.value,
        "sc_team":teamval.target.sc_team.value,
        "coaching_team":teamval.target.coaching_team.value
     }
     dispatch({ type: INJURYCHART_ACTION });
    axios.post(AppConfig.apiurl+'/api/editinjurychart', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allInjuryChart()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: EDIT_INJURYCHART });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}


export const deleteInjuryChart = (id) => async (dispatch) => {
    
    var payload={
        "id":id
     }
     dispatch({ type: INJURYCHART_ACTION });
    axios.post(AppConfig.apiurl+'/api/deleteinjurychart', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allInjuryChart()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: DELETE_INJURYCHART });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

// Injury Update
export const allInjuryUpdate = (id) => {
    
    
   return (dispatch) => { 
       dispatch({ type: INJURYUPDATE_ACTION });
       var payload={ "id":id }
       return axios.post(AppConfig.apiurl+'/api/getinjuryupdate', payload, { headers: AuthHeader.header })         
       .then(response => {             
           const allroles=response.data.data;
           const resdata=response.data;
           dispatch({ type: ALL_INJURYUPDATES, payload: allroles });
           return Promise.resolve(resdata);
       });
   }
   

}

export const addInjuryUpdate = (teamval,sicid) => async (dispatch) => {
   
   var payload={
       "sicid":sicid,       
       "seldate":teamval.target.seldate.value,
       "teamid":teamval.target.teamid.value,      
       "provisional_diagnosis":teamval.target.provisional_diagnosis.value,
       "injury_severity":teamval.target.injury_severity.value,
       "update_rehabilitation":teamval.target.update_rehabilitation.value,
       "plan_action":teamval.target.plan_action.value,
       "note_sc_team":teamval.target.note_sc_team.value,
       "note_coaching_team":teamval.target.note_coaching_team.value,
       "note_tsg_team":teamval.target.note_tsg_team.value
    }
    dispatch({ type: INJURYUPDATE_ACTION });
   return axios.post(AppConfig.apiurl+'/api/addinjuryupdate', payload, { headers: AuthHeader.header })
    .then( response => {       
        if(response.status==200){ 
           var resdata=response.data;
           if(resdata.status===1){
              allInjuryUpdate(sicid)(dispatch);
              NotificationManager.success(resdata.message);               
              dispatch({ type: ADD_INJURYUPDATE });
           }else{
              NotificationManager.error(resdata.message); 
           }
        }else{
           NotificationManager.error('Injury update not added');
        }            
        return Promise.resolve(resdata);
    })
    .catch( error => { 
      NotificationManager.error(error);
    });
}

export const fetchInjuryUpdate = (id) => async (dispatch) => {
  
  var payload={
     "id":id
  }
  
    dispatch({ type: INJURYUPDATE_ACTION});
      return axios.post(AppConfig.apiurl+'/api/fetchinjuryupdate', payload, { headers: AuthHeader.header })
        .then( response => {   
           var resdata=response.data;	
           var resvalue=resdata.data;			
           dispatch({ type: FETCH_INJURYUPDATE, payload:resvalue[0]}); 
           return Promise.resolve(resdata);
           
        })
        .catch( error => { 
           const errormsg=error.message
           NotificationManager.error(errormsg);
        });

  
}

export const editInjuryUpdate = (teamval,id,scid) => async (dispatch) => {
   
   var payload={
      "id":id,       
      "seldate":teamval.target.seldate.value,
      "teamid":teamval.target.teamid.value,      
      "provisional_diagnosis":teamval.target.provisional_diagnosis.value,
      "injury_severity":teamval.target.injury_severity.value,
      "update_rehabilitation":teamval.target.update_rehabilitation.value,
      "plan_action":teamval.target.plan_action.value,
      "note_sc_team":teamval.target.note_sc_team.value,
      "note_coaching_team":teamval.target.note_coaching_team.value,
      "note_tsg_team":teamval.target.note_tsg_team.value
   }
    dispatch({ type: INJURYUPDATE_ACTION });
   axios.post(AppConfig.apiurl+'/api/editinjuryupdate', payload, { headers: AuthHeader.header })
    .then( response => {       
        if(response.status==200){ 
           var resdata=response.data;
           if(resdata.status===1){
               allInjuryUpdate(scid)(dispatch);
              NotificationManager.success(resdata.message);               
              dispatch({ type: EDIT_INJURYUPDATE });
           }else{
              NotificationManager.error(resdata.message); 
           }
        }            
        
    })
    .catch( error => { 
      NotificationManager.error(error);
    });
}


export const deleteInjuryUpdate = (id,scid) => async (dispatch) => {
   
   var payload={
       "id":id
    }
    dispatch({ type: INJURYUPDATE_ACTION });
   axios.post(AppConfig.apiurl+'/api/deleteinjuryupdate', payload, { headers: AuthHeader.header })
    .then( response => {       
        if(response.status==200){ 
           var resdata=response.data;
           if(resdata.status===1){
               allInjuryUpdate(scid)(dispatch);
              NotificationManager.success(resdata.message);               
              dispatch({ type: DELETE_INJURYUPDATE });
           }else{
              NotificationManager.error(resdata.message); 
           }
        }            
        
    })
    .catch( error => { 
      NotificationManager.error(error);
    });
}

export const getstudentinjurylist = (id) => {
    
    
   return (dispatch) => { 
       dispatch({ type: INJURYUPDATE_ACTION });
       var payload={ "id":id }
       return axios.post(AppConfig.apiurl+'/api/getstudentinjury', payload, { headers: AuthHeader.header })         
       .then(response => {             
           const allroles=response.data.data;
           const resdata=response.data;
           dispatch({ type: ALL_STUDENTINJURY, payload: allroles });
           return Promise.resolve(resdata);
       });
   }
   

}

export const fetchInjuryDetails = (id) => {
    
    
   return (dispatch) => { 
       dispatch({ type: INJURYUPDATE_ACTION });
       var payload={ "id":id }
       return axios.post(AppConfig.apiurl+'/api/getinjurydetails', payload, { headers: AuthHeader.header })         
       .then(response => {             
           const alldata=response.data.data;
           const injurydata=alldata.injurydetails[0];
           const updatedata=alldata.injuryupdates;           
           const resdata=response.data;
           dispatch({ type: FULL_INJURYDETAIL, payload: injurydata });
           dispatch({ type: INJURY_UPDATEDETAIL, payload: updatedata });
           return Promise.resolve(resdata);
       });
   }
   

}

export const updateInjuryProfile = (teamval) => async (dispatch) => {
   
   var payload={
         "id":teamval.target.eid.value,  
         "teamid":teamval.target.teamid.value,
        "age":teamval.target.age.value,
        "gender":teamval.target.gender.value,
        "skill":teamval.target.skill.value,
        "chief_complaint":teamval.target.chief_complaint.value,
        "mechanism_injury":teamval.target.mechanism_injury.value,
        "history_present_injury":teamval.target.history_present_injury.value,
        "history_injury_past":teamval.target.history_injury_past.value,
        "observations_assessment":teamval.target.observations_assessment.value,
        "clinical_findings":teamval.target.clinical_findings.value,
        "provisional_diagnosis":teamval.target.provisional_diagnosis.value,
        "injury_severity":teamval.target.injury_severity.value,
        "plan_action":teamval.target.plan_action.value,
        "return_sports":teamval.target.return_sports.value
   }
    dispatch({ type: INJURYUPDATE_ACTION });
   axios.post(AppConfig.apiurl+'/api/editinjuryprofile', payload, { headers: AuthHeader.header })
    .then( response => {       
        if(response.status==200){ 
           var resdata=response.data;
           if(resdata.status===1){               
              NotificationManager.success(resdata.message);               
              dispatch({ type: EDIT_INJURYPROFILE });
           }else{
              NotificationManager.error(resdata.message); 
           }
        }            
        
    })
    .catch( error => { 
      NotificationManager.error(error);
    });
}


export const updateInjuryupdate = (teamval) => async (dispatch) => {
   
   var payload={
      "id":teamval.target.uid.value, 
      "update_rehabilitation":teamval.target.update_rehabilitation.value,
      "plan_action":teamval.target.plan_action.value
   }
    dispatch({ type: INJURYUPDATE_ACTION });
   axios.post(AppConfig.apiurl+'/api/updateinjuryup', payload, { headers: AuthHeader.header })
    .then( response => {       
        if(response.status==200){ 
           var resdata=response.data;
           if(resdata.status===1){
              NotificationManager.success(resdata.message);               
              dispatch({ type: PROFILE_INJURYUPDATE });
           }else{
              NotificationManager.error(resdata.message); 
           }
        }            
        
    })
    .catch( error => { 
      NotificationManager.error(error);
    });
}

export const uploadInjuryReport = (teamval, upfile) =>{
   let scid=teamval.target.eid.value;
   var payload={
      "id":teamval.target.eid.value, 
      "name":teamval.target.reportname.value, 
      "fileupl":upfile
   }

   return (dispatch) => { 
    dispatch({ type: INJURYUPDATE_ACTION });
    return axios.post(AppConfig.apiurl+'/api/uploadinjuryreport', payload, { headers: AuthHeader.header })
    .then( response => {       
        if(response.status==200){ 
           var resdata=response.data;
           if(resdata.status===1){
              fetchInjuryReports(scid)(dispatch);
              NotificationManager.success(resdata.message);               
              dispatch({ type: PROFILE_INJURYREPORT });
           }else{
              NotificationManager.error(resdata.message); 
           }
           return Promise.resolve(resdata);
        }            
        
    });
    

   }
}

export const fetchInjuryReports = (id) => {
    
    
   return (dispatch) => { 
       dispatch({ type: INJURYUPDATE_ACTION });
       var payload={ "id":id }
       return axios.post(AppConfig.apiurl+'/api/getuploadedinjuryreport', payload, { headers: AuthHeader.header })         
       .then(response => {             
           const alldata=response.data.data;         
           const resdata=response.data;
           dispatch({ type: ALL_INJURYREPORTS, payload: alldata });
           return Promise.resolve(resdata);
       });
   }
   

}


export const deleteInjuryReports = (id,scid) => async (dispatch) => {
    
   var payload={
       "id":id
    }
    dispatch({ type: INJURYUPDATE_ACTION });
   axios.post(AppConfig.apiurl+'/api/deleteuploadedinjuryreport', payload, { headers: AuthHeader.header })
    .then( response => {       
        if(response.status==200){ 
           var resdata=response.data;
           if(resdata.status===1){
              fetchInjuryReports(scid)(dispatch);
              NotificationManager.success(resdata.message);               
              dispatch({ type: DELETE_INJURYREPORTS });
           }else{
              NotificationManager.error(resdata.message); 
           }
        }            
        
    })
    .catch( error => { 
      NotificationManager.error(error);
    });
}

export const updateInjuryReport = (teamval) => async (dispatch) => {
   
   var payload={
      "id":teamval.target.eid.value, 
      "name":teamval.target.updname.value
   }
    dispatch({ type: INJURYUPDATE_ACTION });
   axios.post(AppConfig.apiurl+'/api/updateinjuryreport', payload, { headers: AuthHeader.header })
    .then( response => {       
        if(response.status==200){ 
           var resdata=response.data;
           if(resdata.status===1){
              
              NotificationManager.success(resdata.message);               
              dispatch({ type: PROFILE_INJURYREPORT });
           }else{
              NotificationManager.error(resdata.message); 
           }
        }            
        
    })
    .catch( error => { 
      NotificationManager.error(error);
    });
}


export const allInjuryprofile = () =>{
    
    
   return (dispatch) => { 
       dispatch({ type: INJURYCHART_ACTION });
       return axios.get(AppConfig.apiurl+'/api/getinjuryprofilelist', { headers: AuthHeader.header })         
       .then(response => {             
           const allresp=response.data.data;
           dispatch({ type: ALL_INJURYPROFILE, payload: allresp });
       });
   }
   

}

export const fetchInjuryAllProfile = (id) => {
    
    
   return (dispatch) => { 
       dispatch({ type: INJURYUPDATE_ACTION });
       var payload={ "id":id }
       return axios.post(AppConfig.apiurl+'/api/getstudentinjuryprofile', payload, { headers: AuthHeader.header })         
       .then(response => {             
           const alldata=response.data.data;       
           const resdata=response.data;
           dispatch({ type: FULL_INJURYPROFILE, payload: alldata });
           return Promise.resolve(resdata);
       });
   }
   

}

